import { useCallback, useEffect, useRef, useState } from "react";

export function useAsync<T>(loader: () => Promise<T>, deps: React.DependencyList) {
  const loaderRef = useRef(loader);
  loaderRef.current = loader;
  const [data, setData] = useState<T>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error>();
  // Callers provide the resource keys; the loader itself is read from a ref to avoid render loops.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const run = useCallback(async () => { setLoading(true); setError(undefined); try { const value = await loaderRef.current(); setData(value); return value; } catch (reason) { setError(reason instanceof Error ? reason : new Error("加载失败")); } finally { setLoading(false); } }, deps);
  useEffect(() => { void run(); }, [run]);
  return { data, setData, loading, error, retry: run };
}
